import * as Util from './util.js';

class Header
{
  // ---------------------------------------------------------------------------------------------------------
	// --	Header
	// ---------------------------------------------------------------------------------------------------------

  constructor(){

    //DOM参照
    const holder = this;
    this.header = $(".p-header");
    this.nav = this.header.find(".p-header__nav");
    this.main = this.nav.find(".p-header__navMain");
    this.sns = this.nav.find(".p-header__navSNS");
    this.menu = this.header.find(".p-header__menu");

    //バーガーボタンのボタンアクション
    this.menu.on("click", (e)=>{
      e.preventDefault();
      if(!this.menu.hasClass("close"))
      {
        this.open();
      }
      else
      {
        this.close();
      }
    });

    //ナビゲーション&ロゴのアクション（TOPのみ）
    if($("#top").length)
    {
      $(".p-header__logo >a").click(function(e){
        e.preventDefault();
        const anchorTag = $(this).attr("href").split("#")[1];
        Util.scrollTo(anchorTag);
      });

      this.main.find(">li a").click(function(e){
        e.preventDefault();
        const anchorTag = $(this).attr("href").split("#")[1];
        Util.scrollTo(anchorTag);
        holder.close();
      });
    }
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	開閉
	// ---------------------------------------------------------------------------------------------------------

  open(){
    this.nav.addClass("open");
    this.menu.addClass("close");
  }

  close(){
    this.nav.removeClass("open");
    this.menu.removeClass("close");
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default Header;
